<template>
  <div class="company-fixe">
    <div class="company-btn">
      <div class="company-btnItem" @click="companyTab(index)" :class="{'active': activeIndex == index}" v-for="(item, index) in compatyData" :key="item.catid">
        <span>{{item.name}}</span>
      </div>
    </div>
    <div class="company-tabs">
      <div class="company-tabs-item">
        <div class="company-info">
          <p v-html="activeContent"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: 0,
      childName: '',
      activeNmaes: '',
      activeId: 0,
      activeContent: ''
    }
  },
  props: {
    compatyData: Array
  },
  methods: {
    async getData () {
      const { data: res3 } = await this.$http.get('/fdata/category?catid=104')
      this.activeId = res3.data[0].child[this.activeIndex].catid
      const { data: res } = await this.$http.get(`/fdata/page_show?catid=${this.activeId}`)
      if (res.code === 1) {
        this.activeContent = res.data.content
        console.log(res.data)
      }
    },
    companyTab (index) {
      this.activeIndex = index
      this.activeNmaes = this.compatyData[this.activeIndex].name
      this.$emit('change', this.activeNmaes)
      this.getData()
    },
  },
  mounted () {
    if (this.compatyData.length > 0) {
      this.childName = this.compatyData[this.activeIndex]
    }
    if (Number(this.$route.query.layIndex) > 0) {
      this.activeIndex = this.$route.query.layIndex
    }
    this.getData()
  },
  watch: {
    $route (to, from) {
      this.activeIndex = this.$route.query.layIndex
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");

</style>
